import { render } from "./website.vue?vue&type=template&id=19d8f18a"
import script from "./website.vue?vue&type=script&lang=js"
export * from "./website.vue?vue&type=script&lang=js"

import exportComponent from "D:\\portfolio\\bhavindabhi\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__